//Déclaration des différentes routes de l'application
import Header from './containers/Layout/Header'
import * as modules from './containers/ExtranetContainers'
import { AFFAIR_TYPE, CONTRACT_TYPE } from './redux/affair/affairConstants';

function createDefaultPrivateRoute(path, main, title, exact) {
    return {
        path: path,
        exact: exact,
        main: main,
        header: Header,
        title: title,
    };
}

//Routes privées
export const privateRoutes = [
    createDefaultPrivateRoute('/', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/index.html', modules.Home, "Accueil", true),
    createDefaultPrivateRoute('/parks', modules.Parks, "Parcs machines", true),
    createDefaultPrivateRoute('/parks/park', modules.Park, "Parc machines", true),
    createDefaultPrivateRoute('/parks/park/componentPark', modules.ComponentPark, "Equipement", true),
    createDefaultPrivateRoute('/interventions', modules.Interventions, "Interventions", true),
    createDefaultPrivateRoute('/interventions/intervention', modules.Intervention, "Intervention", true),
    createDefaultPrivateRoute('/quotes', modules.Quotes, "Devis", true),
    createDefaultPrivateRoute('/affairs', modules.Affairs, "Contrats et affaires", true),
    createDefaultPrivateRoute('/affairs/affair', modules.Affair, "", true),
    createDefaultPrivateRoute('/invoices', modules.Invoices, "Factures", true),
    createDefaultPrivateRoute('/contactUs', modules.ContactUs, "Nous contacter", true),
    createDefaultPrivateRoute(undefined, modules.NotFound, "Page 404", false),
];

//Routes publiques (pas besoin d'être identifié)
export const publicRoutes = [
    { path: '/Login', main: modules.Login },
    { path: '/NotFound', main: modules.NotFound },
    { path: '/ConfirmPasswordRenewal/:token', main: modules.ConfirmPasswordRenewal }
];

export function getBreadcrumbComplementName(route, props) {
    if (route === "intervention" && props.currentIntervention)
        return props.currentIntervention.name;

    if (route === "componentPark" && props.currentComponent)
        return props.currentComponent.complete_name;

    if (route === "park" && props.currentPark)
        return props.currentPark.name;

    if (route === "affair" && props.affair) {
        let title = AFFAIR_TYPE;

        if (props.affair.affair_type === CONTRACT_TYPE)
            title = CONTRACT_TYPE;

        return title + " " + props.affair.name;
    }

    return "";
}
